import { g as __rest, b as __assign } from '../../../../_tslib-7a01aab4.js';
import React from 'react';

var ListNoData = function (_a) {
    var children = _a.children, _b = _a.text1, text1 = _b === void 0 ? 'no bets' : _b, _c = _a.text2, text2 = _c === void 0 ? 'add bets' : _c, rest = __rest(_a, ["children", "text1", "text2"]);
    return (React.createElement("div", __assign({ className: "no-data-wrapper" }, rest),
        children,
        React.createElement("p", { className: 'no-data-txt-1' }, text1),
        React.createElement("p", { className: 'no-data-txt-2' }, text2)));
};

export { ListNoData };
